var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchRegularWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0217 17.8302C5.68839 17.8302 2.17578 14.3176 2.17578 9.98425C2.17578 7.90302 3.00211 5.90862 4.4727 4.43523C7.58755 1.42123 12.5539 1.50246 15.5679 4.61451C18.3831 7.5206 18.5088 12.0602 15.9453 15.1123L21.6492 20.8162C21.8677 21.0347 21.8677 21.3904 21.6492 21.6089C21.5399 21.7153 21.3999 21.7742 21.2514 21.7742C21.103 21.7742 20.9601 21.7153 20.8565 21.6089L15.16 15.9124C13.7407 17.1489 11.916 17.8353 10.0217 17.8302ZM10.0217 3.25876C6.30743 3.25876 3.29623 6.26997 3.29623 9.98425C3.29623 11.7686 4.00491 13.4773 5.26542 14.7406C7.90127 17.3568 12.1618 17.34 14.778 14.7041C17.3803 12.0823 17.3803 7.8526 14.778 5.23075C13.5175 3.96184 11.806 3.25316 10.0217 3.25876Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRegularWhite);
export default __webpack_public_path__ + "static/media/search-regular-white.809d85e4386c9a9d7f6f5705af07f3a1.svg";
export { ForwardRef as ReactComponent };